import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('jira_platform_issue_realtime_updates_used_in_nin');
	},
};
